import { ReactElement } from 'react';

export const DisplayItem = (item: any): ReactElement => {
  return item.renderItem();
};
